/** @jsx jsx */
import React, { Component } from 'react';
import { css, jsx } from '@emotion/core';
import styled from '@emotion/styled';

import DetailARDigramOneImg from "./DetailsARSolutionDiagram1.png";
import DetailARDigramTwoImg from "./DetailsARSolutionDiagram2.png";
import DetailARFactoryOneImg from './DetailsARSolutionFactory1.png';
import DetailARFactoryTwoImg from './DetailsARSolutionFactory2.png';
import DetailARFactoryThreeImg from './DetailsARSolutionFactory3.png';

const Section = styled.section`
  border: 0px solid #dadce0;

  color: #363a3c;
  
  font-family: 'Malgun Gothic';
  font-family: 'Noto Sans KR', sans-serif;
  font-family: 'Spoqa Han Sans', 'Spoqa Han Sans JP', 'Sans-serif';
`;
const SubSection = styled.div`
  margin-bottom: 50px;
`;
const ContainerFluid = styled.div`
  margin-left: auto;
  margin-right: auto;
  padding: 16px 24px;

  box-sizing: border-box;
  max-width: 1140px;
`;
const HighlightText = styled.h1`
  margin-top: 0;
  margin-bottom: 0;
  word-break: break-all;
  font-size: 20px;
  line-height: 1.6;
  
  box-sizing: border-box;
`;
const CssHeaderText100 = css`
  font-weight: 100;
`;
const CssHeaderText300 = css`
  font-weight: 300;
`;
const CssHeaderText400 = css`
  font-weight: 400;
`;

const DivFlexboxWrap = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`;
const DivFlexItem = styled.div`
  border: 0px solid #dadce0;
  box-sizing: border-box;
  width: 360px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 30px 0px;
`;
const DivFlexboxNoWrap = styled.div`
  display: flex;
  justify-content: center;
`;
const DivFlexItemNoWrap = styled.div`
  border: 0px solid #dadce0;
  box-sizing: border-box;
  padding-top: 20px;
`;
const ImgFlexItemNoWrap = styled.img`
  width: 100%;
`;

const SpanAbsoluteBold = styled.span`
  position: absolute;
  font-weight: 700;
`;
const DivIndent20 = styled.div`
  margin-left: 20px;
`;

class DetailsARSolution extends Component {
  render() {
    return (
      <div className="DetailsARSolution">

        <Section className="section">
          <ContainerFluid className="container-fluid">

            <SubSection className="Intro">
              <p className="header-text-300" css={CssHeaderText300}>봄시스템즈는 AR기술을 개발, 이를 활용하여 고객사의 산업현장, 특히 생산 현장의 작업 능률을 향상하고, 안전을 제고할 수 있는 방안을 제안하고자 합니다.</p>
              <p className="header-text-300" css={CssHeaderText300}>특히, Smart Glasses와 AR/VR 기술의 접목을 통해 생산성을 향상하고, 산업 안전을 제고하는 방안을 제안하고자 합니다.</p>

              <DivFlexboxWrap className="DivFlexboxWrap">
                <DivFlexItem><img src={DetailARFactoryOneImg}/></DivFlexItem>
                <DivFlexItem><img src={DetailARFactoryTwoImg}/></DivFlexItem>
                <DivFlexItem><img src={DetailARFactoryThreeImg}/></DivFlexItem>
              </DivFlexboxWrap>
            </SubSection>

            <SubSection className="SecurePrinting">
              <HighlightText className="header-text">
                <span className="CssHeaderText400">AR기반 스마트 현장환경 및 설비 관리</span>
              </HighlightText>

              <DivFlexboxNoWrap className="DivFlexboxNoWrap">
                <DivFlexItemNoWrap><ImgFlexItemNoWrap src={DetailARDigramOneImg}/></DivFlexItemNoWrap>
              </DivFlexboxNoWrap>
            </SubSection>

            <SubSection className="SecurePrinting">
              <HighlightText className="header-text">
                <span className="CssHeaderText400">현장작업자 원격 지원 및 협업</span>
              </HighlightText>

              <DivFlexboxNoWrap className="DivFlexboxNoWrap">
                <DivFlexItemNoWrap><ImgFlexItemNoWrap src={DetailARDigramTwoImg}/></DivFlexItemNoWrap>
              </DivFlexboxNoWrap>
            </SubSection>

          </ContainerFluid>
        </Section>

      </div>
    );
  }
}

export default DetailsARSolution;
